import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { cn } from '~/lib/utils'
import { ButtonLabel } from '../ui/button'
import { LinkButton } from '../ui/button'
import { Text } from '../ui/text'

export function PolicyLinks({
  theme = 'dark',
  className,
  linkClassName: linkClassNameProp,
}: {
  theme?: 'light' | 'dark'
  className?: string
  linkClassName?: string
}) {
  const { t } = useTranslations()
  const textClassName = cn(theme === 'light' ? 'text-tertiary-foreground' : 'text-primary')

  const linkClassName = cn('px-2 py-1', linkClassNameProp)

  return (
    <View
      className={cn('w-full flex-row flex-nowrap items-center justify-center gap-0', className)}>
      <LinkButton variant="link" href="/privacy-policy" className={linkClassName}>
        <ButtonLabel className={textClassName}>{t(($) => $.menu.privacyPolicy)}</ButtonLabel>
      </LinkButton>
      <Text className={textClassName}>•</Text>
      <LinkButton variant="link" href="/terms-of-service" className={linkClassName}>
        <ButtonLabel className={textClassName}>{t(($) => $.menu.termsOfService)}</ButtonLabel>
      </LinkButton>
      <Text className={textClassName}>•</Text>
      <LinkButton variant="link" href="/cookie-policy" className={linkClassName}>
        <ButtonLabel className={textClassName}>{t(($) => $.menu.cookiePolicy)}</ButtonLabel>
      </LinkButton>
    </View>
  )
}
